module.exports = __webpack_public_path__ + "img/progress_100.4f21a0e4.png";